<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("docnumber") }}</label>
                  <b-form-input
                    disabled
                    :placeholder="$t('docnumber')"
                    v-model="PurReqTotalForNextYear.docnumber"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("docdate") }}</label>
                  <!-- <date-picker
                    v-model="PurReqTotalForNextYear.docdate"
                    format="DD.MM.YYYY"
                    style="width:100%"
                    value-type="format"
                    :editable="true"
                    :placeholder="$t('docdate')"
                  ></date-picker> -->
                  <custom-date-picker
              v-model="PurReqTotalForNextYear.docdate"
              format="DD.MM.YYYY"
              type="date"
              :clearable="false"
              :placeholder="$t('docdate')"
              @keyup="BindValue"
            >
            </custom-date-picker>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("finyear") }}</label>
                  <v-select
                    :options="FinYearList"
                    :reduce="(item) => item"
                    :placeholder="$t('ChooseBelow')"
                    label="name"
                    v-model="PurReqTotalForNextYear.finyear"
                  ></v-select>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div>
                  <label>{{ $t("settlecodelevel") }}</label>
                  <b-form-input
                    :placeholder="$t('100010')"
                    v-model="PurReqTotalForNextYear.settlecodelevel"
                    v-mask="'######'"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mt-2">
                  <label>{{ $t("functionalitemcode") }}</label>
                  <b-form-input
                    :placeholder="$t('7092-100-075')"
                    v-model="PurReqTotalForNextYear.functionalitemcode"
                    v-mask="'####-###-###'"
                  ></b-form-input>
                </div>
              </b-col>

              <b-col sm="12" md="9">
                <div class="mt-2">
                  <label>{{ $t("detailinfo") }}</label>
                  <b-form-textarea
                    :placeholder="$t('detailinfo')"
                    v-model="PurReqTotalForNextYear.detailinfo"
                    type="text"
                  ></b-form-textarea>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" md="12" lg="12">
          <b-card>
            <b-row>
              <b-col
                cols="12"
                class="text-right mb-2"
                style="text-align:end !important"
              >
                <b-button @click="FillTable" size="sm" variant="success">
                  <b-spinner v-if="FillLoading" small></b-spinner>
                  <i class="bx bx-downvote"></i>
                  {{ $t("FillTable") }}
                </b-button>
              </b-col>
            </b-row>
            <b-tabs pills>
              <b-tab active :title="$t('quantityByPeriod')">
                <b-table-simple
                  striped
                  sticky-header
                  hover
                  bordered
                  small
                  responsive="sm"
                  class="text-center mt-2"
                >
                  <b-thead class="text-center ">
                    <b-tr class="text-center">
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;width:50px !important"
                        class="text-center"
                      >
                        {{ $t("№") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("productcategory") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("product") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("unitofmeasure") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("itemofexpense") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("yearly") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month1") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month2") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month3") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month4") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month5") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month6") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month7") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month8") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month9") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month10") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month11") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month12") }}
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody
                    v-for="(item, index) in PurReqTotalForNextYearForTables"
                    :key="index"
                  >
                    <b-tr>
                      <b-td class="text-right" style="width:50px !important">{{
                        item.ordernumber
                      }}</b-td>
                      <b-td class="text-left">{{
                        item.productcategoryname
                      }}</b-td>
                      <b-td class="text-left">{{ item.productname }}</b-td>
                      <b-td class="text-left">{{
                        item.unitofmeasurename
                      }}</b-td>
                      <b-td class="text-left">{{
                        item.itemofexpensename
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Yearly,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month1,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month2,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month3,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month4,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month5,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month6,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">
                        {{
                          $options.filters.currency(
                            item.QuantityByPeriod.Month7,
                            {
                              symbol: "  ",
                              fractionCount: 2,
                            }
                          )
                        }}</b-td
                      >
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month8,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month9,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month10,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month11,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(
                          item.QuantityByPeriod.Month12,
                          {
                            symbol: "  ",
                            fractionCount: 2,
                          }
                        )
                      }}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-tab>
              <b-tab :title="$t('priceByPeriod')">
                <b-table-simple
                  striped
                  sticky-header
                  hover
                  bordered
                  small
                  responsive="sm"
                  class="text-center mt-2"
                >
                  <b-thead class="text-center ">
                    <b-tr class="text-center">
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("№") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("productcategory") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("product") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("unitofmeasure") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("itemofexpense") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("yearly") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month1") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month2") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month3") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month4") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month5") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month6") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month7") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month8") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month9") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month10") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month11") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month12") }}
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody
                    v-for="(item, index) in PurReqTotalForNextYearForTables"
                    :key="index"
                  >
                    <b-tr>
                      <b-td class="text-right">{{ item.ordernumber }}</b-td>
                      <b-td class="text-left">{{
                        item.productcategoryname
                      }}</b-td>
                      <b-td class="text-left">{{ item.productname }}</b-td>
                      <b-td class="text-left">{{
                        item.unitofmeasurename
                      }}</b-td>
                      <b-td class="text-left">{{
                        item.itemofexpensename
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Yearly, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month1, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month2, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month3, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month4, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month5, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month6, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">
                        {{
                          $options.filters.currency(item.PriceByPeriod.Month7, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month8, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month9, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month10, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month11, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.PriceByPeriod.Month12, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-tab>
              <b-tab :title="$t('sumByPeriod')">
                <b-table-simple
                  striped
                  sticky-header
                  small
                  bordered
                  class="text-center mt-2"
                >
                  <b-thead class="text-center ">
                    <b-tr class="text-center">
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("№") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("productcategory") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("product") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("unitofmeasure") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("itemofexpense") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("yearly") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month1") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month2") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month3") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month4") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center "
                      >
                        {{ $t("month5") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center "
                      >
                        {{ $t("month6") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month7") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;"
                        class="text-center"
                      >
                        {{ $t("month8") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month9") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month10") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month11") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month12") }}
                      </b-th>
                      <!-- <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("Quarter1") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("Quarter2") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("Quarter3") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("Quarter4") }}
                      </b-th> -->
                    </b-tr>
                  </b-thead>
                  <b-tbody
                    v-for="(item, index) in PurReqTotalForNextYearForTables"
                    :key="index"
                  >
                    <b-tr>
                      <b-td class="text-right">{{ item.ordernumber }}</b-td>
                      <b-td class="text-left">{{
                        item.productcategoryname
                      }}</b-td>
                      <b-td class="text-left">{{ item.productname }}</b-td>
                      <b-td class="text-left">{{
                        item.unitofmeasurename
                      }}</b-td>
                      <b-td class="text-left">{{
                        item.itemofexpensename
                      }}</b-td>
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        ><b>{{
                          $options.filters.currency(item.SumByPeriod.Yearly, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month1, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month2, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month3, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month4, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month5, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month6, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                      >
                        {{
                          $options.filters.currency(item.SumByPeriod.Month7, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10% !important;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month8, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month9, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month10, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month11, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month12, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <!-- <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.SumByPeriod.Quarter1, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.SumByPeriod.Quarter2, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.SumByPeriod.Quarter3, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right" style="white-space: nowrap">{{
                        $options.filters.currency(item.SumByPeriod.Quarter4, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td> -->
                    </b-tr>
                  </b-tbody>
                  <b-tfoot>
                    <b-tr
                      style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;"
                    >
                      <b-td
                        colspan="5"
                        class="text-left"
                        style="font-weight:bold"
                        ><b>{{ $t("Total") }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalYear, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth1, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth2, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth3, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth4, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth5, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth6, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth7, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth8, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right">
                        <b>{{
                          $options.filters.currency(total.TotalMonth9, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b>
                      </b-td>
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth10, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth11, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalMonth12, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <!-- <b-td class="text-right">{{
                        $options.filters.currency(total.TotalQuater1, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right">{{
                        $options.filters.currency(total.TotalQuater2, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right">{{
                        $options.filters.currency(total.TotalQuater3, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td>
                      <b-td class="text-right">{{
                        $options.filters.currency(total.TotalQuater4, {
                          symbol: "  ",
                          fractionCount: 2,
                        })
                      }}</b-td> -->
                    </b-tr>
                  </b-tfoot>
                </b-table-simple>
              </b-tab>
              <b-tab :title="$t('MonthForOrgTables')">
                <b-table-simple
                  striped
                  sticky-header
                  small
                  bordered
                  class="text-center mt-2"
                >
                  <b-thead class="text-center ">
                    <b-tr class="text-center">
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("№") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("docnumber") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("docdate") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("organization") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;white-space:nowrap"
                        class="text-center"
                      >
                        {{ $t("organizationaccount") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("yearly") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month1") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month2") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month3") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month4") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center "
                      >
                        {{ $t("month5") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center "
                      >
                        {{ $t("month6") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month7") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;"
                        class="text-center"
                      >
                        {{ $t("month8") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month9") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month10") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month11") }}
                      </b-th>
                      <b-th
                        style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7"
                        class="text-center"
                      >
                        {{ $t("month12") }}
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-for="(item, index) in PurReqOrgTable" :key="index">
                    <b-tr>
                      <b-td class="text-right">{{ item.ordernumber }}</b-td>
                      <b-td class="text-right">{{ item.docnumber }}</b-td>
                      <b-td class="text-right">{{ item.docdate }}</b-td>
                      <b-td class="text-left">{{ item.organizationname }}</b-td>
                      <b-td class="text-right">{{
                        item.organizationaccountname
                      }}</b-td>
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Yearly, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month1, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month2, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month3, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month4, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month5, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month6, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month7, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month8, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month9, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month10, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month11, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                      <b-td
                        class="text-right"
                        style="width:10%;white-space: nowrap"
                        >{{
                          $options.filters.currency(item.SumByPeriod.Month12, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b-td
                      >
                    </b-tr>
                  </b-tbody>
                  <b-tfoot>
                    <b-tr
                      style="vertical-align:middle;background-color:#C6E2FF;border:1px solid #318CE7;"
                    >
                      <b-td colspan="5" class="text-left"
                        ><b>{{ $t("Total") }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseYear, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth1, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth2, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth3, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth4, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth5, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth6, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth7, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth8, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(total.TotalPurchaseMonth9, {
                            symbol: "  ",
                            fractionCount: 2,
                          })
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(
                            total.TotalPurchaseMonth10,
                            {
                              symbol: "  ",
                              fractionCount: 2,
                            }
                          )
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(
                            total.TotalPurchaseMonth11,
                            {
                              symbol: "  ",
                              fractionCount: 2,
                            }
                          )
                        }}</b></b-td
                      >
                      <b-td class="text-right"
                        ><b>{{
                          $options.filters.currency(
                            total.TotalPurchaseMonth12,
                            {
                              symbol: "  ",
                              fractionCount: 2,
                            }
                          )
                        }}</b></b-td
                      >
                    </b-tr>
                  </b-tfoot>
                </b-table-simple>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-left">
                <b-button
                  @click="$router.push('/document/purreqtotalfornextyear')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  v-if="PurReqTotalForNextYear.CanSave"
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import PurReqTotalForNextYearService from "@/services/document/purreqtotalfornextyear.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import CustomDatePicker from '../../../components/customDatePicker.vue'
export default {
  components: {
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
    vSelect,
    CustomDatePicker
  },
  data() {
    return {
      title: this.$t("PurReqTotalForNextYear"),
      braedcrumb: [
        {
          text: this.$t("Document"),
        },
        {
          text: this.$t("PurReqTotalForNextYear"),
          active: true,
        },
      ],
      items: [],
      PurReqTotalForNextYear: {},
      isLoading: false,
      FinYearList: [],
      editedIndex1: -1,
      editedIndex2: -1,
      number: [],
      lang: "ru",
      FillLoading: false,
      FillTotal: {},
      PurReqTotalForNextYearForTables: [],
      PurReqOrgTable: [],
      total: {
        TotalMonth1: 0,
        TotalMonth2: 0,
        TotalMonth3: 0,
        TotalMonth4: 0,
        TotalMonth5: 0,
        TotalMonth6: 0,
        TotalMonth7: 0,
        TotalMonth8: 0,
        TotalMonth9: 0,
        TotalMonth10: 0,
        TotalMonth11: 0,
        TotalMonth12: 0,
        TotalQuater1: 0,
        TotalQuater2: 0,
        TotalQuater3: 0,
        TotalQuater4: 0,
        TotalSum: 0,
        TotalYear: 0,
        TotalPurchaseYear: 0,
        TotalPurchaseMonth1: 0,
        TotalPurchaseMonth2: 0,
        TotalPurchaseMonth3: 0,
        TotalPurchaseMonth4: 0,
        TotalPurchaseMonth5: 0,
        TotalPurchaseMonth6: 0,
        TotalPurchaseMonth7: 0,
        TotalPurchaseMonth8: 0,
        TotalPurchaseMonth9: 0,
        TotalPurchaseMonth10: 0,
        TotalPurchaseMonth11: 0,
        TotalPurchaseMonth12: 0,
      },
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetAllFinYear().then((res) => {
      this.FinYearList = res.data;
    });
    PurReqTotalForNextYearService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.PurReqTotalForNextYear = res.data.result.PurchaseRequisitionTotal;
        this.PurReqTotalForNextYearForTables = res.data.result.MonthTables;
        this.PurReqOrgTable = res.data.result.MonthForOrgTables;
        this.calculate();
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    BindValue(value){
      this.PurReqTotalForNextYear.docdate = value
    },
    FillTable() {
      this.FillLoading = true;
      PurReqTotalForNextYearService.FillPurReqTotalForNextYear(
        this.PurReqTotalForNextYear
      )
        .then((res) => {
          this.FillLoading = false;
          this.PurReqTotalForNextYear = res.data.result;
          this.PurReqTotalForNextYearForTables = res.data.result.MonthTables;
          this.PurReqOrgTable = res.data.result.MonthForOrgTables;
          this.calculate();
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
          this.FillLoading = false;
        });
    },

    calculate() {
      this.total = {
        TotalMonth1: 0,
        TotalMonth2: 0,
        TotalMonth3: 0,
        TotalMonth4: 0,
        TotalMonth5: 0,
        TotalMonth6: 0,
        TotalMonth7: 0,
        TotalMonth8: 0,
        TotalMonth9: 0,
        TotalMonth10: 0,
        TotalMonth11: 0,
        TotalMonth12: 0,
        TotalQuater1: 0,
        TotalQuater2: 0,
        TotalQuater3: 0,
        TotalQuater4: 0,
        TotalSum: 0,
        TotalYear: 0,
        TotalPurchaseYear: 0,
        TotalPurchaseMonth1: 0,
        TotalPurchaseMonth2: 0,
        TotalPurchaseMonth3: 0,
        TotalPurchaseMonth4: 0,
        TotalPurchaseMonth5: 0,
        TotalPurchaseMonth6: 0,
        TotalPurchaseMonth7: 0,
        TotalPurchaseMonth8: 0,
        TotalPurchaseMonth9: 0,
        TotalPurchaseMonth10: 0,
        TotalPurchaseMonth11: 0,
        TotalPurchaseMonth12: 0,
      };
      for (var i = 0; i < this.PurReqTotalForNextYearForTables.length; i++) {
        this.total.TotalMonth1 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month1;
        this.total.TotalMonth2 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month2;
        this.total.TotalMonth3 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month3;
        this.total.TotalMonth4 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month4;
        this.total.TotalMonth5 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month5;
        this.total.TotalMonth6 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month6;
        this.total.TotalMonth7 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month7;
        this.total.TotalMonth8 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month8;
        this.total.TotalMonth9 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month9;
        this.total.TotalMonth10 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month10;
        this.total.TotalMonth10 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month10;
        this.total.TotalMonth11 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month11;
        this.total.TotalMonth12 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Month12;
        this.total.TotalQuater1 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Quarter1;
        this.total.TotalQuater2 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Quarter2;
        this.total.TotalQuater3 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Quarter3;
        this.total.TotalQuater4 +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Quarter4;
        this.total.TotalYear +=
          1 * this.PurReqTotalForNextYearForTables[i].SumByPeriod.Yearly;
      }
      for (var j = 0; j < this.PurReqOrgTable.length; j++) {
        this.total.TotalPurchaseYear +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Yearly;
        this.total.TotalPurchaseMonth1 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month1;
        this.total.TotalPurchaseMonth2 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month2;
        this.total.TotalPurchaseMonth3 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month3;
        this.total.TotalPurchaseMonth4 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month4;
        this.total.TotalPurchaseMonth5 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month5;
        this.total.TotalPurchaseMonth6 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month6;
        this.total.TotalPurchaseMonth7 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month7;
        this.total.TotalPurchaseMonth8 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month8;
        this.total.TotalPurchaseMonth9 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month9;
        this.total.TotalPurchaseMonth10 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month10;
        this.total.TotalPurchaseMonth11 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month11;
        this.total.TotalPurchaseMonth12 +=
          1 * this.PurReqOrgTable[j].SumByPeriod.Month12;
      }
    },
    rowClass(item, type) {
      if (item.Status === 3) return "d-none";
    },

    AddRow() {
      if (!this.checkTable()) {
        return false;
      }
      if (this.editedIndex1 > -1) {
        Object.assign(
          this.PurReqTotalForNextYear.Tables[this.editedIndex1],
          this.tabrow
        );
      } else {
        this.PurReqTotalForNextYear.Tables.push(this.tabrow);
      }
      this.ModalShow = false;
    },

    check() {
      if (
        this.PurReqTotalForNextYear.docnumber === 0 ||
        this.PurReqTotalForNextYear.docnumber === null ||
        this.PurReqTotalForNextYear.docnumber === undefined ||
        this.PurReqTotalForNextYear.docnumber === ""
      ) {
        this.$notification(this.$t("docnumberNotSelected"), "danger");
        return false;
      }
      if (
        this.PurReqTotalForNextYear.docdate === 0 ||
        this.PurReqTotalForNextYear.docdate === null ||
        this.PurReqTotalForNextYear.docdate === undefined ||
        this.PurReqTotalForNextYear.docdate === ""
      ) {
        this.$notification(this.$t("docdateNotSelected"), "danger");
        return false;
      }
      if (
        this.PurReqTotalForNextYear.finyear === 0 ||
        this.PurReqTotalForNextYear.finyear === null ||
        this.PurReqTotalForNextYear.finyear === undefined ||
        this.PurReqTotalForNextYear.finyear === ""
      ) {
        this.$notification(this.$t("finyearNotSelected"), "danger");
        return false;
      }
      if (this.PurReqTotalForNextYear.Tables.length === 0) {
        this.$notification(this.$t("TablesNotSelected"), "danger");
        return false;
      }

      return true;
    },

    SaveData() {
      if (!this.check()) {
        return false;
      }
      PurReqTotalForNextYearService.Update(this.PurReqTotalForNextYear)
        .then((res) => {
          this.$notification(this.$t("SuccessMessage"), "success");
          this.$router.push({ name: `purreqtotalfornextyear` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style>
/* .mx-input {
  background-color: #eff2f7 !important;
} */
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
/* .ClassForBGRawMatPrice
  .table.b-table
  > thead
  > tr:nth-child(2)
  > th[aria-colindex="2"] {
  z-index: 3;
}

.mysticky > .table.b-table > thead > tr:nth-child(2) > th {
  position: sticky;
  position: -webkit-sticky;
  top: 60px;
  z-index: 1;
  background-color: #ced2d8;
  vertical-align: middle;
  text-align: center;
}

.mysticky.table td {
  padding-top: 4px;
  padding-bottom: 4px;
  vertical-align: middle;
}

tr.mystickyheader > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  z-index: 2;
  background-color: #ced2d8;
  vertical-align: middle;
}
.OverFlowXMy {
  height: 40vh;
  min-width: 2800px;
}
.bg-color-table thead {
  background-color: #ced2d8;
} */
/* th {
 position: sticky;
	position: -webkit-sticky;
	top: 0px;
	z-index: 2;} */
/* * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
} */

/* table {
  border-collapse: collapse;
  height: 10px;
  overflow: scroll;
  min-width:100px ;
} */

/* thead {
  background-color: #eee;
  color: gray;
  left: 0;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
} */
/* thead th {
  background-color: #ddd;
}
thead th,
thead td {
  box-shadow: 0 0 0 1px #ccc;
} */

th,
td {
  min-width: 150px;
  padding: 0.5em;
}

th {
  background-color: #eee;
  box-shadow: 1px 0 0 0 #ccc;
  left: 0;
  min-width: 5em;
  position: -webkit-sticky;
  position: sticky;
}
</style>
